module.exports = __webpack_public_path__ + "static/intertec_screen_3.2-82a0c637d856a4d1dd23fd7c3fa6e6bb.jpg";